// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {395: "7108f59755",495: "1d17dd3c1c",}[chunkId] + ".css"
}